// Import all theme assets
import tradofinaLogo from "assets/svg/transparent_logo.svg";
import plebLogo from "assets/svg/pleb-logo.svg";
// Import background images
import tradofinaBg from "assets/images/bg.png";
import plebBg from "assets/svg/pleb-bg.png";
import mobileLogo from "assets/svg/logo.png";


// Theme configurations for different domains
const DOMAIN_THEMES = {
  "tradofina.com": {
    logo: tradofinaLogo,
    mobileLogo:mobileLogo,
    backgroundImage: tradofinaBg,
    brandName: "Tradofina",
    favicon: "/favicon.svg",
    logoTheme: {
      background: tradofinaBg,
      minHeight: "80px"
    },
    clearIconStyle: {
      backgroundColor: "#000",
      color: "#FFF"
    },
    colors: {
      primary: "#430B9C", // Material UI default primary
      secondary: "#dc004e", // Material UI default secondary
      background: "#f5f5f5", // Light gray background
      text: "#333333", // Dark gray text
      buttonprimary: "#430B9C",
      // Add more color variables as needed
    },
    // Add other theme-specific properties
  },
  "plebgraph.com": {
    logo: plebLogo,
    mobileLogo:plebLogo,
    backgroundImage: plebBg,
    brandName: "Plebgraph",
    favicon: "/favicon.png",
    logoTheme: {
      background: "#F8F9FA",
      padding: "20px",
      minHeight: "65px"
    },
    drawerStyle: {
      borderRight: "1px solid #E2E5EC",
    },
    clearIconStyle: {
      backgroundColor: "#FFF",
      color: "#000"
    },
    colors: {
      primary: "#262961", // Updated primary color
      secondary: "#ff9800", // Orange secondary
      background: "#ffffff", // White background
      text: "#000000", // Black text
      buttonprimary: "#0080C5",
      // Add more color variables as needed
    },
    // Add other theme-specific properties
  },
  // Add more domain themes as needed
};

// Default theme (used when no domain match is found)
const DEFAULT_THEME = {
  logo: tradofinaLogo,
  backgroundImage: tradofinaBg,
  favicon: "/favicon.svg",
  colors: {
    primary: "#430B9C",
    secondary: "#dc004e",
    background: "#f5f5f5",
    text: "#333333",
    
  },
};

/**
 * Gets the theme configuration for the current domain
 * @returns {Object} Theme configuration object
 */
export const getThemeByDomain = () => {
    const hostname = window.location.hostname;
    // const hostname = "new-admin-panel.test.tradofina.com";


  // Find the matching domain in our themes
  const domain = Object.keys(DOMAIN_THEMES).find((domain) =>
    hostname.includes(domain),
  );

  // Return the matching theme or default theme
  return domain ? DOMAIN_THEMES[domain] : DEFAULT_THEME;
};

/**
 * Gets a specific theme property for the current domain
 * @param {string} property - The theme property to retrieve (e.g., 'logo', 'colors.primary')
 * @param {any} defaultValue - Default value if property is not found
 * @returns {any} The requested theme property value
 */
export const getThemeProperty = (property, defaultValue = null) => {
  const theme = getThemeByDomain();

  // Handle nested properties (e.g., 'colors.primary')
  return property
    .split(".")
    .reduce(
      (obj, key) => (obj && obj[key] !== undefined ? obj[key] : defaultValue),
      theme,
    );
};

// Export theme colors as CSS variables for global use
export const getThemeVariables = () => {
  const { colors } = getThemeByDomain();
  return {
    "--primary-color": colors.primary,
    "--secondary-color": colors.secondary,
    "--background-color": colors.background,
    "--text-color": colors.text,
    // Add more CSS variables as needed
  };
};

// Apply theme to document root (call this in your app's entry point)
export const applyTheme = () => {
  const root = document.documentElement;
  const variables = getThemeVariables();
  const theme = getThemeByDomain();

  Object.entries(variables).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });

  //   if (theme.backgroundImage) {
  //     root.style.backgroundImage = `url(${theme.backgroundImage})`;
  //   }
};
